import React, { useEffect, useState } from "react";
import { Button, Grid, TextField, MenuItem, Checkbox, FormGroup, FormControlLabel, Typography } from '@mui/material'
import { DatePicker } from '@mui/lab';
import GridBreak from '../../../../components/GridBreak'
import IFramePopUp from '../../../../components/Pop_ups/IFramePopUp';
import DragFiles from "../../../../components/FileManagement/DragFiles";
import { fileTo64Arr, handleFormNumbers } from "../../../../util/generalHelp";
import { createContractDraft, submitDraft, removeOfferDraft, getFieldClause } from "../../../../util/offerLettersHelp";
import { previewDocusign } from "../../../../util/docusignHelper";
import { useBeforeunload } from 'react-beforeunload';
import { useBackListener } from "../../../../util/Hooks";
import moment from "moment";
import { getProfileFromEmail } from "../../../../util/ProfileHelper";

function TenNinetyNine(props) {

    const defaultObj = {
            document_args: {
                "salary": 0,
                "job_title": "",
                "rate_type": "daily",
                venue: 'New York, NY',
                jurisdiction: 'New York',
            },
            region: 'USA',
            name: "",
            email_address: "",
            authority_id: null,
            "return_url": window.location.origin.toString(),
            venue_id: "",
            state_id: "",
    
        }

    /* All of the fields that can be added to the Master of Services agreement, which initially we assume are not present */   
    const defaultFields1099 = {
        non_exclusive: false,
        subcontractor_placement: false,
        relationship_parties: false,
        SEQ_duties: false,
        placement_term: false,
        intellectual_property: false,
        non_competition_subcontractor: false,
        termination: false,
        indemnification: false,
        heading: true,
        entire_agreement:true,
        governing: true,
        notices: true,
        customMasterServices: false
    }

    const defaultFields1099StatementOfWork = {
        services: false,
        performance_period: false,
        fees: false,
        payment_terms: false,
        customStatementOfWork: false
    }


    const changeField1099 = function (field, value) {
        let newFields1099 = { ...fields1099 }
        newFields1099[field] = value
        if (!value)
        {
            const keyClause = field
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
        }
        setFields1099(newFields1099)
    }

    const changeField1099StatementOfWork = function (field, value) {
        let newFields1099StatementOfWork = { ...fields1099StatementOfWork }
        if (!value)
        {
            const keyClause = field
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
        }
        newFields1099StatementOfWork[field] = value
        setFields1099StatementOfWork(newFields1099StatementOfWork)
    }

    const handleDefaultClause = function (keyClause, contract, checked)
    {
        props.setLoading(true)
        if (checked)
        {
            if (!defaultContractText[keyClause])
                getFieldClause(keyClause, contract, 'usa_contract', (json) =>
            {
                if (json)
                {
                    let newDefaultContractText = {...defaultContractText}
                    newDefaultContractText[keyClause] = json.clauses
                    setDefaultContractText(newDefaultContractText)
                    let newShowEdits = {...showEditClause}
                    newShowEdits[keyClause] = true
                    setShowEditClause(newShowEdits)
                }
                else
                    props.setError("The requested clause text could not be fetched. This is usually due to server error.")
                props.setLoading(false)
            })
            else
            {
                let newShowEdits = {...showEditClause}
                newShowEdits[keyClause] = true
                setShowEditClause(newShowEdits)
                props.setLoading(false)
            }
        }
        else
        {
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
            props.setLoading(false)
        }
    }

    const [requestObj, setRequestObj] = useState({ ...defaultObj })
    const [previewUrl, setPreviewUrl] = useState()
    const [previewClicked, setPreviewClicked] = useState(false)
    const [envelopeId, setEnvelopeId] = useState("")
    const [fileArr, setFileArr] = useState([])
    const [uploadStatus, setUploadStatus] = useState('error')
    const [fields1099, setFields1099] = useState({ ...defaultFields1099 })
    const [fields1099StatementOfWork, setFields1099StatementOfWork] = useState({ ...defaultFields1099StatementOfWork })
    const [defaultContractText, setDefaultContractText] = useState({})
    const [showEditClause, setShowEditClause] = useState({})
    const [checkAll, setCheckAll] = useState(false)

    useEffect(() => {
        if (fields1099StatementOfWork.services)
        {
            let newObj = {...requestObj}
            newObj['document_args']['client_name'] = ""
            newObj['document_args']['service_description'] = ""
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['client_name']
            delete newObj['document_args']['service_description']
            setRequestObj(newObj)
        }
    }    
    , [fields1099StatementOfWork.services])

    useEffect(() => {
        if (fields1099StatementOfWork.payment_terms)
        {
            let newObj = {...requestObj}
            newObj['document_args']['reciept_clause_included'] = true
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['reciept_clause_included']
            setRequestObj(newObj)
        }
    }    
    , [fields1099StatementOfWork.payment_terms])

    useEffect(() => {
        if (fields1099StatementOfWork.performance_period)
        {
            let newObj = {...requestObj}
            newObj['document_args']['effective_date'] = moment().format('YYYY-MM-DD')
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['effective_date']
            setRequestObj(newObj)
        }
    }    
    , [fields1099StatementOfWork.performance_period])

    useEffect(() => {
        if (fields1099StatementOfWork.fees)
        {
            let newObj = {...requestObj}
            newObj['document_args']['rate_type'] = "daily"
            newObj['document_args']['salary'] = 0
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['rate_type']
            delete newObj['document_args']['salary']
            setRequestObj(newObj)
        }
    }    
    , [fields1099StatementOfWork.fees])

    useEffect(() => {
            if (fileArr && fileArr.length > 0) {
                setUploadStatus('success')
            } else {
                setUploadStatus('pending')
            }
        }, [fileArr])

    useBackListener(({ location }) => {
            if (requestObj.id) {
                removeOfferDraft(requestObj.id, (resp) => { }, true)
            }
        })
    
    
        useBeforeunload((event) => {
            if (requestObj.id) {
                removeOfferDraft(requestObj.id, (resp) => { }, true)
    
            }
        });

    const closePreview = () => {
            setPreviewClicked(false)
            previewDocusign(envelopeId, (json) => {
                if (json) {
                    setPreviewUrl(json.redirect_url)
                }
            })
        }

    const updateDocument = (key, value) => {
            let newDoc = { ...requestObj }
            if (key == 'seq_hire_helper') {
                newDoc['document_args']['seq_hire_statement'] = defaultObj.document_args.seq_hire_statement.replace(/X/, `${value}`)
                // console.log("value,",newDoc['document_args']['seq_hire_statement'] )
            }
                newDoc['document_args'][key] = value
            console.log('newDoc', newDoc)
            setRequestObj(newDoc)
        }

    const handleDraft = async () => {
            if (previewUrl && requestObj.id) {
                props.setLoading(true)
                submitDraft(requestObj.id, envelopeId, (resp) => {
                    if (resp) {
                        console.log('submission successful')
                        setRequestObj(defaultObj)
                        setFileArr([])
                        setPreviewUrl()
                        setEnvelopeId("")
                        if (props.onComplete) {
                            props.onComplete()
                        }
                    } else {
                        props.onError({})
                    }
                    props.setLoading(false)
                })
            } else {
                props.setLoading(true)
                setPreviewUrl()
                if (checkJson(requestObj.document_args)) {
                    getProfileFromEmail(async (profile) => 
                    {
                    let request_obj = { ...requestObj }
                    request_obj.document_b64s = await handleFile(fileArr)
                    const jsonSend = {request_obj: request_obj, contract: '1099', fields: ['fields1099', 'fieldsStatementOfWork'], fields1099: fields1099, fieldsStatementOfWork: fields1099StatementOfWork, default_changes: defaultContractText, sender: profile.id}
                    console.log('jsonSend', jsonSend)
                    createContractDraft(jsonSend, (resp) => {
                        if (resp) {
                            updateOffer('id', resp.id)
                            setPreviewUrl(resp.redirect_url)
                            setUploadStatus('disabled')
                            setEnvelopeId(resp.envelope_id)
                        } else {
                            props.onError({})
                        }
                        props.setLoading(false)
                    })
                })
                } else {
                    props.onError({ errorTitle: 'Missing Form Fields', errorContent: "Please fill out all available form fields" })
                    props.setLoading(false)
                }
    
            }
    
        }
    
    const checkJson = (json) => {
            for (const key of Object.keys(json)) {
                if (json[key] === null || json[key] === undefined || json[key] === '') {
                    console.log('key', key)
                    if (!props.optionalFields.includes(key))
                        return false
                }
    
                if (json[key].constructor == Object) {
                    if (!checkJson(json[key])) {
                        return false
                    }
                    continue
                }
            }
            return true
        }
    
        const updateOffer = (key, value, del = false) => {
            let newOffer = { ...requestObj }
            if (!del) {
                newOffer[key] = value
                setRequestObj(newOffer)
            } else {
                delete newOffer[key]
                setRequestObj(newOffer)
            }
    
        }    

    const handleClear = () => {
        if (requestObj.id) {
            props.setLoading(true)
            removeOfferDraft(requestObj.id, (resp) => {
                if (resp) {
                    let newOffer = { ...requestObj }
                    delete newOffer['id']
                    setRequestObj(newOffer)
                    setPreviewUrl()
                    setUploadStatus('pending')
                } else {
                    props.onError({})
                }
                props.setLoading(false)
            })
        }
    }

    const handleFile = async (fileArr) => {
        return await fileTo64Arr(fileArr)
    }

    const handleNumberForm = (e, key, document = false, decimals = 0, maxdigits = undefined) => {
        let modfiedNum = handleFormNumbers(e.target.value, decimals, false, maxdigits)
        if (modfiedNum !== undefined) {
            if (document) {
                updateDocument(key, modfiedNum)
            } else {
                updateOffer(key, modfiedNum)
            }
        }
    }


    const handleCheckAll = (e) => {
        let newFields1099 = { ...fields1099 }
        let newFields1099StatementOfWork = { ...fields1099StatementOfWork }
        for (const key of Object.keys(newFields1099)) {
            newFields1099[key] = e.target.checked
        }
        for (const key of Object.keys(newFields1099StatementOfWork)) {
            newFields1099StatementOfWork[key] = e.target.checked
        }
        setFields1099(newFields1099)
        setFields1099StatementOfWork(newFields1099StatementOfWork)
        setCheckAll(e.target.checked)
    }

    //Length is the maximum length of the clause in question, in case there are multiple fields
    const changeDefaultText = function (key, value, index, length)
    {
        let newDefault = {...defaultContractText}
        if (index !== undefined && newDefault[key] !== undefined)
            newDefault[key][index] = value
        else if (index !== undefined)
        {
            newDefault[key] = Array(length)
            //Populate the newly created array with the initial text from the document
            let i = 0
            while (i < length)
            {
                newDefault[key][i] = defaultContractText[key][i]
                i++
            }
            newDefault[key][index] = value
        }
        else
            newDefault[key] = value
        setDefaultContractText(newDefault)
    }

    


    return (
        <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', width: '100%', padding: '1%' }}>
            <IFramePopUp open={previewClicked} url={previewUrl} onClose={closePreview} maxRedirect={2} />
            <Typography sx ={{'align-self': 'flex-start'}} variant='h5'>Choose Fields</Typography>
            <FormGroup item sx={{ width: '100%', padding: '1%' }}>
                <FormControlLabel control={ <Checkbox checked = {checkAll} onChange = {handleCheckAll} /> } label = {"Check/Uncheck All"} />
                <FormControlLabel control={ <Checkbox checked = {fields1099.non_exclusive} onChange = {(e) => changeField1099("non_exclusive", e.target.checked)} /> } label = {"Non Exclusive Relationship"} />
                {fields1099.non_exclusive ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.non_exclusive} onChange = {(e) => handleDefaultClause("non_exclusive", "1099", e.target.checked)} /> } label = {"Edit Non Exclusive Relationship Clause"} />
                        {showEditClause.non_exclusive ?
                        <TextField sx = {{'margin': '1%'}} label="Current Non-Exclusive Relationship Clause"
                            value= {defaultContractText.non_exclusive} onChange= {(e) => changeDefaultText("non_exclusive", e.target.value)} fullWidth required multiline /> : <></>
                        }
                        
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.subcontractor_placement} onChange = {(e) => changeField1099("subcontractor_placement", e.target.checked)} /> } label = {"Placement of Subcontractor"} />
                {fields1099.subcontractor_placement ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.subcontractor_placement} onChange = {(e) => handleDefaultClause("subcontractor_placement", "1099", e.target.checked)} /> } label = {"Edit Placement of Subcontractor Clause"} />
                        {showEditClause.subcontractor_placement ?
                        <TextField sx = {{'margin': '1%'}} label="Current Placement of Subcontractor Clause"
                            value= {defaultContractText.subcontractor_placement} onChange= {(e) => changeDefaultText("subcontractor_placement", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.relationship_parties} onChange = {(e) => changeField1099("relationship_parties", e.target.checked)} /> } label = {"Relationship of the Parties"} />
                {fields1099.relationship_parties ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.relationship_parties} onChange = {(e) => handleDefaultClause("relationship_parties", "1099", e.target.checked)} /> } label = {"Relationship of the Parties Clause"} />
                        {showEditClause.relationship_parties ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Relationship of the Parties Part 1"
                                value= {defaultContractText.relationship_parties[0]} onChange= {(e) => changeDefaultText("relationship_parties", e.target.value, 0, 3)} fullWidth required multiline />
                            <TextField sx = {{'margin': '1%'}} label="Current Relationship of the Parties Part 2"
                                value= {defaultContractText.relationship_parties[1]} onChange= {(e) => changeDefaultText("relationship_parties", e.target.value, 1, 3)} fullWidth required multiline />
                            <TextField sx = {{'margin': '1%'}} label="Current Relationship of the Parties Part 3"
                            value= {defaultContractText.relationship_parties[2]} onChange= {(e) => changeDefaultText("relationship_parties", e.target.value, 2, 3)} fullWidth required multiline />

                        </>
                            : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.SEQ_duties} onChange = {(e) => changeField1099("SEQ_duties", e.target.checked)} /> } label = {"Duties of SEQ"} />
                {fields1099.SEQ_duties ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel item  control={ <Checkbox checked = {showEditClause.SEQ_duties} onChange = {(e) => handleDefaultClause("SEQ_duties", "1099", e.target.checked)} /> } label = {"SEQ Duties Clause"} />
                        {showEditClause.SEQ_duties ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 1"
                            value= {defaultContractText.SEQ_duties[0]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 0, 5)} fullWidth required multiline /> 
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 2"
                            value= {defaultContractText.SEQ_duties[1]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 1, 5)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 3"
                        value= {defaultContractText.SEQ_duties[2]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 2, 5)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 4"
                        value= {defaultContractText.SEQ_duties[3]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 3, 5)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 5"
                            value= {defaultContractText.SEQ_duties[4]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 4, 5)} fullWidth required multiline />
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.placement_term} onChange = {(e) => changeField1099("placement_term", e.target.checked)} /> } label = {"Term of Placement"} />
                {fields1099.placement_term ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.placement_term} onChange = {(e) => handleDefaultClause("placement_term", "1099", e.target.checked)} /> } label = {"Edit Term of Placement Clause"} />
                        {showEditClause.placement_term ?
                        <TextField sx = {{'margin': '1%'}} label="Current Term of Placement Clause"
                            value= {defaultContractText.placement_term} onChange= {(e) => changeDefaultText("placement_term", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.intellectual_property} onChange = {(e) => changeField1099("intellectual_property", e.target.checked)} /> } label = {"Intellectual Property"} />
                {fields1099.intellectual_property ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.intellectual_property} onChange = {(e) => handleDefaultClause("intellectual_property", "1099", e.target.checked)} /> } label = {"Edit Intellectual Property Clause"} />
                        {showEditClause.intellectual_property ?
                        <TextField sx = {{'margin': '1%'}} label="Current Intellectual Property Clause"
                            value= {defaultContractText.intellectual_property} onChange= {(e) => changeDefaultText("intellectual_property", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.non_competition_subcontractor} onChange = {(e) => changeField1099("non_competition_subcontractor", e.target.checked)} /> } label = {"Non-Competition by Subcontractor"} />
                {fields1099.non_competition_subcontractor ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.non_competition_subcontractor} onChange = {(e) => handleDefaultClause("non_competition_subcontractor", "1099", e.target.checked)} /> } label = {"Edit Non-Competition by Subcontractor Clause"} />
                        {showEditClause.non_competition_subcontractor ?
                        <TextField sx = {{'margin': '1%'}} label="Current Non-Competition by Subcontractor Clause"
                            value= {defaultContractText.non_competition_subcontractor} onChange= {(e) => changeDefaultText("non_competition_subcontractor", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.termination} onChange = {(e) => changeField1099("termination", e.target.checked)} /> } label = {"Termination"} />
                {fields1099.termination ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.termination} onChange = {(e) => handleDefaultClause("termination", "1099", e.target.checked)} /> } label = {"Edit Termination Clause"} />
                        {showEditClause.termination ?
                        <TextField sx = {{'margin': '1%'}} label="Current Termination Clause"
                            value= {defaultContractText.termination} onChange= {(e) => changeDefaultText("termination", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.indemnification} onChange = {(e) => changeField1099("indemnification", e.target.checked)} /> } label = {"Indemnification"} />
                {fields1099.indemnification ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.indemnification} onChange = {(e) => handleDefaultClause("indemnification", "1099", e.target.checked)} /> } label = {"Edit Indemnification Clause"} />
                        {showEditClause.indemnification ?
                        <TextField sx = {{'margin': '1%'}} label="Current Indemnification Clause"
                            value= {defaultContractText.indemnification} onChange= {(e) => changeDefaultText("indemnification", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099.customMasterServices} onChange = {(e) => changeField1099("customMasterServices", e.target.checked)} /> } label = {"Add a 1099 Custom Field"} />
                {fields1099.customMasterServices ?
                        <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                            <TextField sx = {{'margin': '1%'}} label="Current 1099 Custom Header"
                                value= {defaultContractText.customMasterServicesHeader} onChange= {(e) => changeDefaultText("customMasterServicesHeader", e.target.value)} fullWidth required />
                            <TextField sx = {{'margin': '1%'}} label="Current 1099 Custom Clause"
                                value= {defaultContractText.customMasterServices} onChange= {(e) => changeDefaultText("customMasterServices", e.target.value)} fullWidth required multiline />
                        </Grid>
                         : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099StatementOfWork.services} onChange = {(e) => changeField1099StatementOfWork("services", e.target.checked)} /> } label = {"Statement of Work Services"} />
                {fields1099StatementOfWork.services ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.services} onChange = {(e) => handleDefaultClause("services", "1099", e.target.checked)} /> } label = {"Edit Services Clause"} />
                        {showEditClause.services ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                            The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Services Clause"
                                value= {defaultContractText.services} onChange= {(e) => changeDefaultText("services", e.target.value)} fullWidth required multiline />     
                        </> 
                        : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099StatementOfWork.fees} onChange = {(e) => changeField1099StatementOfWork("fees", e.target.checked)} /> } label = {"Statement of Work Fees"} />
                <FormControlLabel control={ <Checkbox checked = {fields1099StatementOfWork.performance_period} onChange = {(e) => changeField1099StatementOfWork("performance_period", e.target.checked)} /> } label = {"Statement of Work Performance Period"} />
                {fields1099StatementOfWork.performance_period ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.performance_period} onChange = {(e) => handleDefaultClause("performance_period", "1099", e.target.checked)} /> } label = {"Edit Performance Period Clause"} />
                        {showEditClause.performance_period ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                                The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Performance Period Clause"
                                value= {defaultContractText.performance_period} onChange= {(e) => changeDefaultText("performance_period", e.target.value)} fullWidth required multiline />
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099StatementOfWork.payment_terms} onChange = {(e) => changeField1099StatementOfWork("payment_terms", e.target.checked)} /> } label = {"Statement of Work Payment Terms"} />
                {fields1099StatementOfWork.payment_terms ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.payment_terms} onChange = {(e) => handleDefaultClause("payment_terms", "1099", e.target.checked)} /> } label = {"Edit Payment Terms Clause"} />
                        {showEditClause.payment_terms ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                                The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Payment Terms Clause"
                                value= {defaultContractText.payment_terms} onChange= {(e) => changeDefaultText("payment_terms", e.target.value)} fullWidth required multiline /> 
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fields1099StatementOfWork.customStatementOfWork} onChange = {(e) => changeField1099StatementOfWork("customStatementOfWork", e.target.checked)} /> } label = {"Add a Statement of Work Custom Field"} />
                {fields1099StatementOfWork.customStatementOfWork ?
                        <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                            <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Custom Header"
                                value= {defaultContractText.customStatementOfWorkHeader} onChange= {(e) => changeDefaultText("customStatementOfWorkHeader", e.target.value)} fullWidth required />
                            <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Custom Clause"
                                value= {defaultContractText.customStatementOfWork} onChange= {(e) => changeDefaultText("customStatementOfWork", e.target.value)} fullWidth required multiline />
                        </Grid>
                         : <></>
                }
            </FormGroup>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Signatory Name" onChange={(e) => { e.preventDefault(); updateOffer('name', e.target.value) }}
                            value={requestObj.name} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Contractor Name" onChange={(e) => { e.preventDefault(); updateDocument('contractor_name', e.target.value) }}
                            value={requestObj.document_args.contractor_name} fullWidth required />
                    </Grid>
                    { fields1099StatementOfWork.services ? 
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Client Name" onChange={(e) => { e.preventDefault(); updateDocument('client_name', e.target.value) }}
                            value={requestObj.document_args.client_name} fullWidth required />
                    </Grid> : <></> }
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Contractor Address" onChange={(e) => { e.preventDefault(); updateDocument('contractor_address', e.target.value) }}
                            value={requestObj.document_args.employer_address} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Signatory Email" onChange={(e) => { e.preventDefault(); updateOffer('email_address', e.target.value) }}
                            value={requestObj.email_address} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Job Title" onChange={(e) => { e.preventDefault(); updateDocument('job_title', e.target.value) }}
                            value={requestObj.document_args.job_title} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Region" required onChange={(e) => { e.preventDefault(); updateOffer('region', e.target.value) }}
                            value={requestObj.region} fullWidth select>
                            <MenuItem key={1} value="CAN">
                                CAN
                            </MenuItem>
                            <MenuItem key={2} value="USA">
                                USA
                            </MenuItem>
                        </TextField>
                    </Grid>
                    {fields1099StatementOfWork.performance_period ? 
                        <Grid item xs={3}>
                        <DatePicker disabled={Boolean(previewUrl)} label="SOW Effective Date" value={requestObj.document_args.effective_date}
                            onChange={(value) => updateDocument('effective_date', value.format('YYYY-MM-DD').toString())}
                            renderInput={(params) => <TextField required fullWidth {...params} />} />
                        </Grid>
                        : <></>
                    }
                    
                    { fields1099StatementOfWork.fees ?
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} label="Payment Type" required onChange={(e) => { e.preventDefault(); updateDocument('rate_type', e.target.value) }}
                                value={requestObj.document_args.rate_type} fullWidth select>
                                <MenuItem key={1} value="daily">
                                    Daily
                                </MenuItem>
                                <MenuItem key={2} value="hourly">
                                    Hourly
                                </MenuItem>
                            </TextField>
                        </Grid> : <></> }
                    { fields1099StatementOfWork.fees ? 
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} SelectProps='0.01' onChange={(e) => {
                                e.preventDefault();
                                handleNumberForm(e, 'salary', true, 2)
                            }}
                                label={requestObj.document_args.rate_type == 'daily' ? "Daily Rate ($)" : 'Hourly Rate ($/hr)'}
                                value={requestObj.document_args.salary} fullWidth required />
                        </Grid>    
                    : <></>
                    }
                    {fields1099StatementOfWork.services ?
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Service Description" onChange={(e) => { e.preventDefault(); updateDocument('service_description', e.target.value) }}
                            value={requestObj.document_args.service_description} fullWidth required multiline />
                    </Grid>
                    : <></> }
                    { fields1099StatementOfWork.payment_terms ?
                    <Grid item xs={3}>
                        <TextField label="5 Days Reciept Clause Included" required disabled={previewUrl} onChange={(e) => { e.preventDefault(); updateDocument('reciept_clause_included', e.target.value) }}
                            value={requestObj.document_args.reciept_clause_included} fullWidth select>
                            <MenuItem value={true}>
                                Yes
                            </MenuItem>
                            <MenuItem value={false}>
                                No
                            </MenuItem>
                        </TextField>
                    </Grid>
                    : <></> }
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} required label="Jurisdiction"
                            onChange={(e) => { e.preventDefault(); updateOffer('state_id', e.target.value) }}
                            value={requestObj.state_id} fullWidth select>
                            {props.states.map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl) || !requestObj.state_id} required label="Venue"
                            onChange={(e) => { e.preventDefault(); updateOffer('venue_id', e.target.value) }}
                            value={requestObj.venue_id} fullWidth select>
                            {props.venues.filter(v => v.type === requestObj.state_id).map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} required label="Signing Authority" onChange={(e) => { e.preventDefault(); updateOffer('authority_id', e.target.value) }}
                            value={requestObj.authority_id} fullWidth select>
                            {props.authorities.map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}({auth.email_address})
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Statement Of Work Number"
                            onChange={(e) => {
                                e.preventDefault();
                                updateDocument('SOW_number', e.target.value)
                            }}
                            value={requestObj.document_args.SOW_number} fullWidth required multiline />
                    </Grid>
                    <GridBreak />
                    <Grid item container xs={12} sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <DragFiles types={props.fileTypes} multiple={true} disabled={Boolean(previewUrl)} onUpdate={setFileArr}
                            maxSize={15}
                            onTypeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Type Error', errorContent: error }) }}
                            onSizeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Size Error', errorContent: error }) }}
                            uploadStatus={uploadStatus} />
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); handleClear() }}>Cancel</Button>
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); setPreviewClicked(true) }}>Preview Document</Button>
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth onClick={(e) => { e.preventDefault(); handleDraft() }}>{requestObj.id && previewUrl ? "Send" : "Create Draft"}</Button>
                    </Grid>
                </Grid>
    );
}

export default TenNinetyNine;